import React, { useEffect, useState } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  CreatePayroll,
  GetAllPayroll,
} from "../../../../../utils/redux/HR/HRSlice";
import { toast } from "react-toastify";

export default function AddPayroll() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [filter, setFilter] = useState("0");
  const [sort, setSort] = useState(0);
  const [pageSize, setPageSize] = useState(100000);
  const [currentPage, setCurrentPage] = useState(1);
  const { all_payroll } = useSelector((state) => state?.hr);
  const [searchQuery, setSearchQuery] = useState("");

  let statusfilter = filter === "all" ? "" : filter;

  let payroll = all_payroll?.result;
  payroll = payroll?.filter(
    (row) =>
      row.initiatorName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      row.payrollCategory.toLowerCase().includes(searchQuery.toLowerCase()) ||
      row.payrollCycle.toLowerCase().includes(searchQuery.toLowerCase())
  );
  payroll = payroll?.filter(
    (row) => filter === filter || row.Status === "parseInt(filter)"
  );

  // console.log("iibeck", payroll);

  useEffect(() => {
    dispatch(
      GetAllPayroll({
        filter: statusfilter,
        pageSize: pageSize,
        currentPage: currentPage,
        sort,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, pageSize, currentPage, sort]);

  // const filterBy = [
  //   {
  //     name: "All",
  //     filter: "all",
  //   },
  //   {
  //     name: "Approved",
  //     filter: 0,
  //   },
  //   {
  //     name: "Pending",
  //     filter: 1,
  //   },
  //   {
  //     name: "Declined",
  //     filter: 2,
  //   },
  //   {
  //     name: "Cancelled",
  //     filter: 3,
  //   },
  // ];

  //correct //starts
  // Inside your component
  // Inside your component
  const [componentsList, setComponentsList] = useState([]);
  const [selectedPayrollComponent, setSelectedPayrollComponent] = useState([]);
  // const [showInitialComponent, setShowInitialComponent] = useState(true);
  // const [initialComponent, setInitialComponent] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // console.log("componentsList", componentsList);

  //start here

  const handleAddComponent = () => {
    const approvedComponents = payroll.filter(
      (item) => item.status === "Approved"
    );

    const newComponent = (
      <div key={componentsList.length}>
        <label>
          Payroll Components <span>*</span>
        </label>
        <select
          name="percentageComponents"
          onChange={(e) => handleSelectChange(e, approvedComponents)}
        >
          <option value="" disabled>
            Select Payroll Components
          </option>
          {approvedComponents.map((item) => (
            <option key={item.id} value={item.id}>
              {item.componentTitle}
            </option>
          ))}
        </select>
      </div>
    );

    setComponentsList([...componentsList, newComponent]);
  };

  const handleSelectChange = (e, approvedComponents) => {
    const selectedOptions = e.target.selectedOptions;
    const selectedIds = Array.from(selectedOptions).map((option) =>
      parseInt(option.value)
    );

    setSelectedPayrollComponent([...selectedPayrollComponent, ...selectedIds]);

    setFormData((prevData) => ({
      ...prevData,
      percentageComponents: [
        ...prevData.percentageComponents,
        ...selectedIds.map((id) => ({ subComponentId: id })),
      ],
    }));
  };

  const [formData, setFormData] = useState({
    componentTitle: "",
    componentType: "",
    componentDescription: "",
    shortCode: "",
    payrollCategory: "",
    payrollSubCategory: "",
    payrollCycle: "",
    percentageValue: 0,
    percentageComponents: [{ subComponentId: 0 }],
  });

  // const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
      [name]:
        name === "payrollCycle" ||
        name === "payrollCategory" ||
        name === "payrollSubCategory" ||
        name === "componentType"
          ? parseInt(value, 10)
          : value,
    }));
  };

  const resetForm = () => {
    setFormData({
      componentTitle: "",
      componentType: 0,
      componentDescription: "",
      shortCode: "",
      payrollCategory: 0,
      payrollSubCategory: 0,
      payrollCycle: 2,
      percentageValue: 0,
      // percentageComponents: [{ subComponentId: 0 }],
    });
  };

  const handleSubmit = () => {
    // Clear any existing error message
    setErrorMessage("");

    // Initialize an empty payload
    const payload = {};

    // Define the list of fields to include in the payload
    const fields = [
      "componentTitle",
      "componentType",
      "componentDescription",
      "shortCode",
      "payrollCategory",
      "payrollSubCategory",
      "payrollCycle",
      "percentageValue",
    ];

    // Loop through each field and add it to the payload if it exists in formData
    fields.forEach((field) => {
      if (formData[field]) {
        payload[field] = formData[field];
      }
    });

    // Add percentageComponents only if selectedPayrollComponent is not empty
    if (selectedPayrollComponent.length > 0) {
      payload.percentageComponents = selectedPayrollComponent.map((id) => ({
        subComponentId: parseInt(id),
      }));
    }

    console.log("selectedPayrollComponent", selectedPayrollComponent);

    console.log("Submitted payload:", payload);

    // return;

    dispatch(CreatePayroll(payload))
      .then((res) => {
        if (res?.payload?.successful === true) {
          resetForm();
          setTimeout(() => {
            navigate("/dashboard/hr/Payroll-SetUp/");
          }, 2000);
        } else if (res?.payload?.successful === false) {
          // console.log("error", res?.payload?.message);
          toast.error(res?.payload?.statusMessage);
        }
      })
      .catch((error) => {
        // Handle error, if any
        console.error("Error:", error);
      });
  };

  return (
    <PageLayout title={"Add Payroll Item"} hasBack={true}>
      <div className={DashboardStyle.mycontainers}>
        <div>Basic Information</div>
        <div class={DashboardStyle.secondContainer}>
          <div>
            <label>
              Component Title <span>*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Component Title"
              name="componentTitle"
              value={formData.componentTitle}
              onChange={handleChange}
            />
          </div>
          <div>
            <label>
              Component Type <span>*</span>{" "}
            </label>
            <select
              name="componentType"
              value={formData.componentType}
              onChange={handleChange}
            >
              <option value="" disabled>
                Select Component{" "}
              </option>
              <option value={0}>Salary</option>
              <option value={1}>Cooperative</option>
              <option value={2}>PPP (Personal provident plan)</option>
              <option value={3}>Bonus</option>
            </select>
          </div>
          <div>
            <label>
              Payroll Category <span>*</span>{" "}
            </label>
            <select
              name="payrollCategory"
              value={formData.payrollCategory}
              onChange={handleChange}
            >
              <option value="" disabled>
                Select Payroll Category{" "}
              </option>
              <option value={0}>Earning</option>
              <option value={1}>Deduction</option>
            </select>
          </div>
          <div>
            <label>
              Payroll Sub-Category <span>*</span>{" "}
            </label>
            <select
              name="payrollSubCategory"
              value={formData.payrollSubCategory}
              onChange={handleChange}
            >
              <option value="" disabled>
                Select Payroll Sub-Category
              </option>
              <option value={0}>Statutory</option>
              <option value={1}>Non Statutory</option>
            </select>
          </div>
          <div>
            <label>
              Payroll Cycle <span>*</span>{" "}
            </label>
            <select
              name="payrollCycle"
              value={formData.payrollCycle}
              onChange={handleChange}
            >
              <option value="" disabled>
                Select Payroll Cycle
              </option>
              <option value={0}>Hourly</option>
              <option value={1}>Daily</option>
              <option value={2}>Weekly</option>
              <option value={3}>Monthly</option>
              <option value={4}>Quarterly</option>
              <option value={5}>Annually</option>
            </select>
          </div>
          <div>
            <label>
              Short Code <span>*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Short Code"
              name="shortCode"
              value={formData.shortCode}
              onChange={handleChange}
            />
          </div>
          <div className={DashboardStyle.fullWidth}>
            <label>
              Component Description <span>*</span>
            </label>
            <textarea
              rows={6}
              name="componentDescription"
              value={formData.componentDescription}
              onChange={handleChange}
            >
              Enter Component Description
            </textarea>
          </div>

          <div className={DashboardStyle.fullWidth}>
            <label>
              Percentage Value <span>(optional)</span>
            </label>
            <input
              type="number"
              placeholder="Enter Percentage Value"
              name="percentageValue"
              value={formData.percentageValue}
              onChange={handleChange}
            />
          </div>

          {/* {formData.percentageValue > 0 && (
            <>
              {showInitialComponent && (
          <div key={componentsList.length} className={DashboardStyle.fullWidth}>
            <label>Payroll Components <span>*</span></label>
            <select
              name="percentageComponents"
              onChange={(e) => {
                handleChange(e);
                setInitialComponent(e.target.value);
              }}
              value={initialComponent || ''}
            >
              <option value="">Select a component</option>
              {payroll
                .filter((item) => item.status === "Approved")
                .map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.componentTitle} 
                  </option>
                ))}
            </select>
          </div>
        )}

              <div className={DashboardStyle.fullWidth}>
                {componentsList.map((component, index) => (
                  <div key={index}>{component}</div>
                ))}
              </div>
              <div>
                <button
                  className={DashboardStyle.whiteButton5}
                  onClick={handleAddComponent}
                >
                  + Add Component
                </button>
              </div>
            </>
          )} */}

          {formData.percentageValue > 0 && (
            <>
              <div className={DashboardStyle.fullWidth}>{componentsList}</div>
              <div>
                <button
                  className={DashboardStyle.whiteButton5}
                  onClick={handleAddComponent}
                >
                  + Add Component
                </button>
              </div>
            </>
          )}
        </div>
      </div>

      <div className={DashboardStyle.mycontainbutt}>
        <button className={DashboardStyle.greenButton} onClick={handleSubmit}>
          Submit
        </button>
        <button
          className={DashboardStyle.whiteButton}
          onClick={() => navigate(-1)}
        >
          Cancel
        </button>
      </div>

      {errorMessage && (
        <div className={DashboardStyle.errorMessage} style={{ color: "red" }}>
          {errorMessage}
        </div>
      )}
    </PageLayout>
  );
}

// function AddPayroll2() {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { all_payroll, isLoading } = useSelector((state) => state?.hr);

//   const [filter, setFilter] = useState("0");
//   const [sort, setSort] = useState(0);
//   const [pageSize, setPageSize] = useState(100000);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [componentsList, setComponentsList] = useState([]);
//   const [selectedPayrollComponent, setSelectedPayrollComponent] = useState([]);
//   const [formData, setFormData] = useState({
//     componentTitle: "",
//     componentType: 0,
//     componentDescription: "",
//     shortCode: "",
//     payrollCategory: 0,
//     payrollSubCategory: 0,
//     payrollCycle: 2,
//     percentageValue: 0,
//     percentageComponents: [],
//   });
//   const [errorMessage, setErrorMessage] = useState("");

//   useEffect(() => {
//     dispatch(GetAllPayroll({ filter, pageSize, currentPage, sort }));
//   }, [dispatch, filter, pageSize, currentPage, sort]);

//   const handleAddComponent = () => {
//     const approvedComponents = all_payroll?.result?.filter(
//       (item) => item.status === "Approved"
//     );

//     const newComponent = (
//       <div key={componentsList.length}>
//         <label>
//           Payroll Components <span>*</span>
//         </label>
//         <select
//           name="percentageComponents"
//           onChange={(e) => handleSelectChange(e, approvedComponents)}
//           multiple
//         >
//           <option value="" disabled>
//             Select Payroll Components
//           </option>
//           {approvedComponents.map((item) => (
//             <option key={item.id} value={item.id}>
//               {item.componentTitle}
//             </option>
//           ))}
//         </select>
//       </div>
//     );

//     setComponentsList([...componentsList, newComponent]);
//   };

//   const handleSelectChange = (e, approvedComponents) => {
//     const selectedOptions = Array.from(e.target.selectedOptions);
//     const selectedIds = selectedOptions.map((option) => parseInt(option.value));

//     setSelectedPayrollComponent([...selectedPayrollComponent, ...selectedIds]);

//     setFormData((prevData) => ({
//       ...prevData,
//       percentageComponents: [
//         ...prevData.percentageComponents,
//         ...selectedIds.map((id) => ({ subComponentId: id })),
//       ],
//     }));
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: [
//         "payrollCycle",
//         "payrollCategory",
//         "payrollSubCategory",
//         "componentType",
//       ].includes(name)
//         ? parseInt(value, 10)
//         : value,
//     }));
//   };

//   const handleSubmit = () => {
//     setErrorMessage("");

//     const payload = {
//       ...formData,
//       percentageComponents: selectedPayrollComponent.map((id) => ({
//         subComponentId: parseInt(id),
//       })),
//     };

//     dispatch(CreatePayroll(payload))
//       .then((res) => {
//         if (res?.payload?.successful) {
//           resetForm();
//           setTimeout(() => navigate("/dashboard/hr/Payroll-SetUp/"), 2000);
//         } else {
//           toast.error(
//             res?.payload?.statusMessage || "Error submitting payroll"
//           );
//         }
//       })
//       .catch((error) => {
//         setErrorMessage("An error occurred. Please try again.");
//         console.error("Error:", error);
//       });
//   };

//   const resetForm = () => {
//     setFormData({
//       componentTitle: "",
//       componentType: 0,
//       componentDescription: "",
//       shortCode: "",
//       payrollCategory: 0,
//       payrollSubCategory: 0,
//       payrollCycle: 2,
//       percentageValue: 0,
//       percentageComponents: [],
//     });
//     setComponentsList([]);
//     setSelectedPayrollComponent([]);
//   };

//   const filterOptions = [
//     { name: "All", value: "all" },
//     { name: "Approved", value: 0 },
//     { name: "Pending", value: 1 },
//     { name: "Declined", value: 2 },
//     { name: "Cancelled", value: 3 },
//   ];

//   const filteredPayroll = (all_payroll?.result || [])
//     .filter((row) =>
//       [row.initiatorName, row.payrollCategory, row.payrollCycle].some((field) =>
//         field?.toLowerCase().includes(searchQuery.toLowerCase())
//       )
//     )
//     .filter((row) => filter === "all" || row.status === parseInt(filter));

//   return (
//     <PageLayout title={"Add Payroll Item"} hasBack={true}>
//       <div className={DashboardStyle.mycontainers}>
//         <div>Basic Information</div>
//         <div className={DashboardStyle.secondContainer}>
//           {Object.entries(formData).map(
//             ([key, value]) =>
//               key !== "percentageComponents" && (
//                 <div key={key}>
//                   <label>
//                     {key
//                       .replace(/([A-Z])/g, " $1")
//                       .replace(/^./, (str) => str.toUpperCase())}{" "}
//                     <span>*</span>
//                   </label>
//                   {["componentDescription"].includes(key) ? (
//                     <textarea
//                       rows={6}
//                       name={key}
//                       value={value}
//                       onChange={handleChange}
//                     >
//                       Enter {key}
//                     </textarea>
//                   ) : (
//                     <input
//                       type={key === "percentageValue" ? "number" : "text"}
//                       placeholder={`Enter ${key}`}
//                       name={key}
//                       value={value}
//                       onChange={handleChange}
//                     />
//                   )}
//                 </div>
//               )
//           )}

//           {formData.percentageValue > 0 && (
//             <>
//               <div className={DashboardStyle.fullWidth}>{componentsList}</div>
//               <div>
//                 <button
//                   className={DashboardStyle.whiteButton5}
//                   onClick={handleAddComponent}
//                 >
//                   + Add Component
//                 </button>
//               </div>
//             </>
//           )}
//         </div>
//       </div>

//       <div className={DashboardStyle.mycontainbutt}>
//         <button className={DashboardStyle.greenButton} onClick={handleSubmit}>
//           Submit
//         </button>
//         <button
//           className={DashboardStyle.whiteButton}
//           onClick={() => navigate(-1)}
//         >
//           Cancel
//         </button>
//       </div>

//       {errorMessage && (
//         <div className={DashboardStyle.errorMessage} style={{ color: "red" }}>
//           {errorMessage}
//         </div>
//       )}
//     </PageLayout>
//   );
// }
